<template>
    <div class="infobox" v-bind:class="{ 'd-none': !visible }">
        <div class="infobox-header">
            <div class="infobox-close">
                <button class="btn btn--close" v-on:click="hide">x</button>
            </div>
            <div class="infobox-title hyphens-auto">
                <slot name="title"></slot>
            </div>
            <div class="infobox-subline" v-if="$slots.subline">
                <slot name="subline"></slot>
            </div>
        </div>
        <div class="infobox-body">
            <div class="keyline"></div>
            <div class="overflow-area" ref="content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "InfoBox",
        props: ['modalName'],
        data: function ()
        {
            return {
                visible: false,
            };
        },
        methods: {
            hide: function ()
            {
                this.$eventBus.$emit('InfoBox.show', false);
            }
        },
        created()
        {
            this.$eventBus.$on('InfoBox.show', (value) =>
            {
                //console.log('InfoBox.show', value);
                //this.visible = (value !== false);
                if (value === this.modalName)
                {
                    this.$tracking.hotspotClick('Hotspot: ' + value);
                }
                this.visible = (value === this.modalName);

                let self = this;
                this.$nextTick(() =>
                {
                    if (self.$refs.content)
                    {
                        // Scroll Tracking
                        self.$refs.content.scrollTop = 0;
                        self.$tracking.addScroll('InfoBox-' + self.modalName, self.$refs.content);
                    }
                });
            });
        }
    };
</script>

<style scoped lang="scss">

</style>
